import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { OtpService } from 'src/app/services/api/otp.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from '../../../environments/environment';
import { UserInfoModalComponent } from '../modals/user-info-modal/user-info-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  title: string = environment.appNameAcronym;
  currentUser: any;
  defaultFolder: number | undefined;

  locales = environment.locales;

  constructor(
    public userService: UserService,
    public otpService: OtpService,
    public router: Router,
    private modalService: NgbModal,
    public translate: TranslateService,
    public dialog: MatDialog
  ) {}

  changeLocale(locale: string) {
    if (!this.translate.getLangs().includes(locale)) {
      locale = 'fr';
    }
    this.translate.use(locale);
    localStorage.setItem('language', locale);
  }

  ngOnInit() {
    if (this.userService.isAuthenticated()) {
      this.defaultFolder =
        this.userService.currentUser.symfonyUser.defaultFolder;
    }
    if (
      !this.translate.getLangs().includes(localStorage.getItem('language')!)
    ) {
      localStorage.setItem('language', 'fr');
    }
    this.translate.use(localStorage.getItem('language')!);
  }

  getInitial() {
    if (
      this.userService.currentUser.keycloakUser.tokenParsed.family_name &&
      this.userService.currentUser.keycloakUser.tokenParsed.given_name
    ) {
      return (
        this.userService.currentUser.keycloakUser.tokenParsed.family_name.charAt(
          0
        ) +
        this.userService.currentUser.keycloakUser.tokenParsed.given_name.charAt(
          0
        )
      );
    }

    return this.userService.currentUser.keycloakUser.tokenParsed.email;
  }

  openUserInfo() {
    const modalRef = this.modalService.open(UserInfoModalComponent, {
      size: 'lg',
      centered: true,
    });
  }

  // Login method
  login() {
    this.userService.login();
  }

  // Logout method
  logout() {
    this.userService.logout();
  }

  // Account managment method
  accountManagement() {
    this.userService.accountManagement();
  }

  // Check User Role
  hasRole(userRole: string | string[]) {
    let userRoleTesting: any = userRole;

    if (typeof userRoleTesting === 'string') {
      if (this.userService.hasRole(userRoleTesting)) {
        return true;
      } else {
        return false;
      }
    } else {
      let userAccess: boolean = false;

      for (let currentUserRole of userRoleTesting) {
        if (this.userService.hasRole(currentUserRole)) {
          userAccess = true;
        }
      }

      return userAccess;
    }
  }

  hasAttribute(attribute: string) {
    return this.userService.hasAttribute(attribute);
  }

  getAttribute(attribute: string) {
    return this.userService.getAttribute(attribute);
  }

  openHelp() {
    this.dialog.closeAll();
    this.dialog.open(InfoDialog);
  }
}

@Component({
  selector: 'info-dialog',
  templateUrl: 'info-dialog.html',
})
export class InfoDialog {}
